<div class="textSubscription desktop" *ngIf="!IsViewMode">{{'SUBSCRIPTION.ROUTE_SELECTION_TEXT'|translate}}</div>
<div class="row cards-container">
  <div class="roulette-card" [ngClass]="{selected:true}" *ngFor="let subscription of rouletteSubscriptions">
    <img class="bg-img" src="assets/images/roulette-card-bg-{{subscription.color}}.svg" />
    <div *ngIf="subscription.IsCurrentAvailableSubscription" class="selected"> {{'SUBSCRIPTION.CURRENT'|translate}}
    </div>
    <div class="header column">
      <span>{{subscription.NamePackage}}</span>
      <span
        class="spins-count">{{subscription.SpinsCount>0?(subscription.SpinsCount|appendtext:('SUBSCRIPTION.SPINS'|translate))
        :('SUBSCRIPTION.NO_SPINS_LIMIT'|translate)}}</span>
    </div>
    <div class="row details-row full-width">
      <span>{{'SUBSCRIPTION.ROULETTE_EXPIRE'|translate}}</span>
      <span *ngIf="subscription.ExpireDays>0">{{subscription.ExpireDays|appendtext:('ROULETTE.DAYS'|translate)}}</span>
      <span *ngIf="!(subscription.ExpireDays>0)">{{'SUBSCRIPTION.NOEXPIRE'|translate}}</span>
    </div>
    <!-- <div class="row details-row full-width">
      <span>{{'SUBSCRIPTION.CAMPAIGN_SIZE'|translate}}</span>
      <span class="size-value">{{ 'SUBSCRIPTION.' + subscription.campainSize | translate }}</span>
       <i *ngIf="subscription.SpinsCount>0" class="no-icon">{{'GENERAL.NO'|translate}}</i>
      <i *ngIf="!(subscription.SpinsCount>0)" class="yes-icon">{{'GENERAL.YES'|translate}}</i>
    </div>
   -->
    <div class="row details-row full-width">
      <span>{{'SUBSCRIPTION.CUSTOMERS_DATABASE'|translate}}</span>
      <span class="size-value">{{ 'SUBSCRIPTION.' + subscription.customersDatabase | translate }}</span>
      <!-- <i *ngIf="!subscription.DisplayPrivateLogo" class="no-icon">{{'GENERAL.NO'|translate}}</i>
      <i *ngIf="subscription.DisplayPrivateLogo" class="yes-icon">{{'GENERAL.YES'|translate}}</i> -->
    </div>
    <!-- <div class="row details-row full-width">
      <span>{{'SUBSCRIPTION.NO_ATN_ADS'|translate}}</span>
      <i *ngIf="subscription.DisplayAtnAds" class="no-icon"> {{'GENERAL.NO'|translate}}</i>
      <i *ngIf="!subscription.DisplayAtnAds" class="yes-icon"> {{'GENERAL.YES'|translate}}</i>
    </div> -->
    <div class="price column">
      <span *ngIf="subscription.IsFreePackage">{{'SUBSCRIPTION.FREEPRICE'|translate}}</span>
      <span
        *ngIf="!subscription.IsFreePackage">{{subscription.Price|currency:curencyEnum[subscription.Currency]}}</span>
      <span class="sub-price">{{'SUBSCRIPTION.MONTHLY_PAYMENT'|translate}}</span>
    </div>
    <div id="switch-container">
      <div class="row r-form-group switch-container" id="switch">
        <label for="IsYearlyPackage" class="title bold-text" id="labelForMonth">
          {{'ROULETTE.YEARLY_SUBSCRIPTION'|translate:{price:subscription.PriceForYear|currency:curencyEnum[subscription.Currency]}
          }}
        </label>
        <p-inputSwitch name="IsYearlyPackage" [(ngModel)]="subscription.IsYearlyPackage"></p-inputSwitch>
      </div>

      <span id="discount" *ngIf="subscription.Discount">{{
        'ROULETTE.YEARLY_SALE'|translate:{price:subscription.Discount|currency:curencyEnum[subscription.Currency]}
        }}</span>
      <div *ngIf="!subscription.IsYearlyPackage" id="switch" class="row r-form-group switch-container">
        <label class="title bold-text" id="labelForMonth"
          for="autoRenewal">{{'ROULETTE.AUTOMATIC_RENEWAL_AT_THE_END_OF_THE_PERIOD'|translate}}</label>
        <p-inputSwitch name="autoRenewal" [(ngModel)]="subscription.AutoRenewalPackage"></p-inputSwitch>
      </div>
    </div>
    <button id="choose" class="command-button full full-width" blockButtonToSingleClick [blockButtonTime]="3000"
      (click)="selectSubscription(subscription)">
      {{'SUBSCRIPTION.SELECTION' | translate}}
    </button>
  </div>
</div>
<div class="returnLink" *ngIf="!IsViewMode">
  <a class="link" (click)="back()">{{'SUBSCRIPTION.RETURN_TO_PREVIOUS_PAGE'|translate}}</a>
</div>